
export class InfluencerCampaignReach {
  value: 0 | number;
  percent: 0;
}

export class InfluencerCampaignEngagement {
  value: 0;
  percent: 0;
}

export class InfluencerCampaignImpact {
  value: 0;
  percent: 0;
}

export class InfluencerCampaign {
  campaign_influencer_id: number;
  influencer_id: number;
  influencer_name: string;
  campaign_influencer_status: string;
  campaign_influencer_number_of_post: number;
  campaign_influencer_platformBlogs: boolean;
  campaign_influencer_platformInstagram: boolean;
  campaign_influencer_platformYoutube: boolean;
  campaign_influencer_platformSnapchat: boolean;
  campaign_influencer_platformTwitter: boolean;
  campaign_influencer_platformPinterest: boolean;
  campaign_influencer_platformFacebook: boolean;
  campaign_influencer_platformTikTok: boolean;
  campaign_influencer_reach: InfluencerCampaignReach;
  campaign_influencer_engagement: InfluencerCampaignEngagement;
  campaign_influencer_impact: InfluencerCampaignImpact;
  influencer_profile_picture: string | null;
  country_code: string | null;
  country: any | null;
  is_accepted: boolean;
}

export class InfluencerCampaignActivity {
  id: number;
  campaignId: number;
  campaignType: string;
  name: string;
  campaignInfluencerId: number;
  status: string;
  description: string;
}

export class InfluencerCampaignStatus {
  i: number; // index
  value: any;
  name: string;
  selected: boolean | null;
}

export class InfluencerCampaignPost {
  imageUrl: string;
  title: string;
  date: string;
  relativePath: string;
  fullUrl: string;
  platformBlogs: boolean;
  platformInstagram: boolean;
  platformYoutube: boolean;
  platformSnapchat: boolean;
  platformTwitter: boolean;
  platformPinterest: boolean;
  platformFacebook: boolean;
  platformTiktok: boolean;
  reach: number | null;
  engagement: number | null;
  impressions: number | null;
  impact: number | null;
  urlHash: string;
  selected: boolean;
  channelId: number;
  isNew: boolean;
}



// WEBPACK FOOTER //
// ./src/models/influencer-campaign.ts